import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import BelvoirExplorer from './BelvoirExplorer';

/**
 * Full-screen garden explorer. Site chrome (nav, banners, cookies) is hidden
 * on /explore. Uses the updated Blender export (belvoir-gardens.glb).
 */
export default function CastleMapPage() {
  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;
    const prevBody = body.style.overflow;
    const prevHtml = html.style.overflow;
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    return () => {
      body.style.overflow = prevBody;
      html.style.overflow = prevHtml;
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Explore the Gardens — 3D Map | Belvoir Castle</title>
        <meta
          name="description"
          content="Explore Belvoir Castle and gardens in an interactive 3D map built from the estate’s Blender model. Rotate, zoom, and discover places across the grounds."
        />
      </Helmet>
      <BelvoirExplorer assetBase="" embedded={false} />
    </>
  );
}
